import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BACKEND_URI } from '../config/config-vars';
import { InternalInventory } from '../models/internal-inventory.model';

const BASE_URL = `${BACKEND_URI}/api/internal-inventory`;

@Injectable({ providedIn: 'root' })
export class InternalInventoryService {
  constructor(private http: HttpClient) {}

  async getCurrent(): Promise<InternalInventory> {
    return await firstValueFrom(this.http.get<InternalInventory>(BASE_URL));
  }

  async save(inventory: InternalInventory): Promise<InternalInventory> {
    return await firstValueFrom(this.http.put<InternalInventory>(BASE_URL, inventory));
  }
}
